import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { RATING_DIMENSIONS } from "@/constants/ratings";
import type { Ratings } from "@/types";

interface RatingCategoryGridProps {
  ratings: Ratings;
  /** Grid `size` for each column (MUI Grid2). */
  columnSize?: number | { xs?: number; sm?: number; md?: number };
  gridSx?: object;
}

/** Compact 5-column breakdown of per-dimension scores (card or review). */
export default function RatingCategoryGrid({
  ratings,
  columnSize = { xs: 2.4 },
  gridSx,
}: RatingCategoryGridProps) {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} sx={gridSx}>
      {RATING_DIMENSIONS.map(({ key, labelKey }) => (
        <Grid size={columnSize} key={key}>
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
              }}
            >
              {t(labelKey)}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
              }}
            >
              {ratings[key].toFixed(1)}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
